import React, { useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from 'styled-components';
import { TrashBinIcon, XCloseIcon } from '@rsos/assets/icons';
import LatLong from '@rsos/components/capstone/Location/LatLong';
import { Box, Accordion, Text } from '@rsos/components/capstone/base';
import { Button } from '@rsos/components/capstone/base';
import { resetWhat3WordsLocation } from '@rsos/reduxDataStore/src/features/what3words/what3wordsSlice';
import { reset } from '../JurisdictionView/UniversalSearch/searchSlice';
import {
  AccordionWrapper,
  W3wContainer,
  CloseButton,
} from './What3WordsSearchResult.styles';

const HEIGHT_ADJUSTMENT_TIMER = 600; //delay timer for re-adjustment of pane height (parent)

const What3WordsSearchResult = ({
  renderStandalonePane,
  hasW3w,
  setAccordionHeight = () => {},
  accordionHeight = 0,
}) => {
  const theme = useContext(ThemeContext);
  const w3wAccordionRef = useRef(null);
  const dispatch = useDispatch();

  const timedHeightAdjustment = () => {
    setTimeout(() => {
      setAccordionHeight(w3wAccordionRef?.current?.offsetHeight || 0);
    }, HEIGHT_ADJUSTMENT_TIMER);
  };

  useEffect(() => {
    const timerId = timedHeightAdjustment();
    return () => clearTimeout(timerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasW3w, accordionHeight]);

  const location = useSelector(state => state.what3words.searched?.coordinates);
  const selectedLocation = useSelector(
    state => state.gisSearch.selectedLocation,
  );

  const clearW3w = () => {
    setAccordionHeight(0);
    dispatch(resetWhat3WordsLocation());
    if (!selectedLocation) {
      dispatch(reset());
    }
  };

  return (
    <W3wContainer
      isShowing={hasW3w}
      ref={w3wAccordionRef}
      renderStandalonePane={renderStandalonePane}
    >
      <Box pb={2}>
        <Box
          pb={2}
          height="24px"
          horizontal
          align="center"
          justify="space-between"
        >
          <Text color="primaryText"> Search Result </Text>
          {renderStandalonePane && (
            <CloseButton onClick={clearW3w}>
              <XCloseIcon />
            </CloseButton>
          )}
        </Box>
        <AccordionWrapper data-name="w3w-AccordionWrapper-result">
          <Box>
            <Accordion
              isOpened
              noBorder
              header={
                <Box
                  horizontal
                  justify={'space-between'}
                  align={'center'}
                  width={'100%'}
                >
                  <Text fontWeight="bold" size="small" color="primaryText">
                    w3w
                  </Text>
                  {!renderStandalonePane && (
                    <Box pr={'10px'}>
                      <Button
                        btnType="tertiary"
                        size="xsmall"
                        type="button"
                        onClick={clearW3w}
                        noMargin
                      >
                        <TrashBinIcon
                          color={theme.colors.secondaryLink}
                          width={18}
                          height={18}
                        />
                      </Button>
                    </Box>
                  )}
                </Box>
              }
              headerAlign={'center'}
              headerIcon={'caret'}
              headerIconAlign={true}
              interactionType={'button'}
              width={'100%'}
              height={100}
              btnSize={'xsmall'}
              btnType={'invisible'}
              headerPadding={'8px 0'}
              padding={'0'}
              content={
                location && (
                  <LatLong
                    longitude={location.lng}
                    latitude={location.lat}
                    irpVersion
                    w3w
                  />
                )
              }
              callback={timedHeightAdjustment}
            ></Accordion>
          </Box>
        </AccordionWrapper>
      </Box>
    </W3wContainer>
  );
};

export default React.memo(What3WordsSearchResult);
